module.exports = __webpack_public_path__ + "static/media/gingerbread-man.df17381b.svg";